"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montalto-carpasio": {
    "d6072977": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-d-oggia": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "22cde679": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "costorello": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4d38d83": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "faravello": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4c75ed31": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "funtanili": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec76ee3e": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "prati-piani": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a0d7413": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "skipSearch": false
    }],
    "rairan": [{
      "hkey": "b9f76ef0",
      "slug": "montalto-carpasio",
      "name": "Montalto Carpasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;